import { memo, useEffect } from "react";
import { useAtomValue, useSetAtom } from 'jotai';
import { allDisplayedDataBoundsAtom, mapDataDisplayedBoundsAtom } from "../stores/mapStore";
import { elementDisplayedBoundsAtom } from "../Element/ElementStore";
import { commentDisplayedBoundsAtom } from "../Comment/CommentStore";
import { memberDisplayedBoundsAtom } from "../Member/MemberStore";
import { combineBoundsTuples } from "../utils/keyboardShortcutUtils";

const AllDisplayedDataBoundsController = () => {
  const mapDataBounds = useAtomValue(mapDataDisplayedBoundsAtom);
  const elementBounds = useAtomValue(elementDisplayedBoundsAtom);
  const commentBounds = useAtomValue(commentDisplayedBoundsAtom);
  const memberBounds = useAtomValue(memberDisplayedBoundsAtom);
  const setAllDisplayedDataBounds = useSetAtom(allDisplayedDataBoundsAtom);

  useEffect(() => {
    const mergedTuple = combineBoundsTuples([
      mapDataBounds,
      elementBounds,
      commentBounds,
      memberBounds,
    ]);

    if (mergedTuple) {
      setAllDisplayedDataBounds(JSON.stringify(mergedTuple));
    } else {
      setAllDisplayedDataBounds(null);
    }
  }, [mapDataBounds, elementBounds, commentBounds, memberBounds, setAllDisplayedDataBounds]);

  return null;
};

export default memo(AllDisplayedDataBoundsController);
